(function () {
  const selectors = [
    '.twoll-home-collections h2',
    '.twoll-home-collections__card',
    '.twoll-home-about__media',
    '.twoll-home-about__content',
    '.twoll-home-articles__header',
    '.twoll-home-articles__card',
    '.twoll-demo-footer__press-item',
    '.twoll-demo-footer__social',
    '.twoll-demo-footer__image-card',
    '.twoll-demo-footer__nav a',
    '.twoll-demo-footer__social-links a',
    '.twoll-demo-footer__legal',
    '.twoll-collection__header',
    '.twoll-collection__crosslinks a',
    '.twoll-collection__tools',
    '.twoll-collection__faq details',
    '.twoll-product-card',
    '.twoll-product__gallery',
    '.twoll-product__media',
    '.twoll-product__details',
    '.twoll-product__accordions details',
    '.twoll-cart__header',
    '.twoll-cart__empty',
    '.twoll-cart__item',
    '.twoll-cart__summary',
    '.twoll-cart__perk',
    '.twoll-faq__header',
    '.twoll-faq details',
    '.twoll-stockists h1',
    '.twoll-stockists__grid article',
    '.twoll-stockists article',
    '.twoll-about-page__intro',
    '.twoll-about-page__why',
    '.twoll-about-page__timeline',
    '.twoll-about-page__vibes',
    '.twoll-blog__card',
    '.twoll-article__image',
    '.twoll-article__content',
    '.twoll-search-page__header',
    '.twoll-search-page__text-card',
    '.twoll-search-page__empty',
    '.twoll-list-collections__card',
    '.twoll-404',
    '.twoll-contact__intro',
    '.twoll-contact__form',
    '.twoll-customer__panel'
  ];

  const scaleSelectors = [
    '.twoll-home-collections__card',
    '.twoll-home-articles__card',
    '.twoll-product-card',
    '.twoll-demo-footer__image-card',
    '.twoll-list-collections__card',
    '.twoll-article__image'
  ];

  const fadeSelectors = [
    '.twoll-demo-footer__nav a',
    '.twoll-demo-footer__social-links a',
    '.twoll-demo-footer__legal'
  ];

  const staggerParents = [
    '.twoll-home-collections__grid',
    '.twoll-home-articles__grid',
    '.twoll-demo-footer__press',
    '.twoll-demo-footer__image-grid',
    '.twoll-demo-footer__nav',
    '.twoll-collection__grid',
    '.twoll-blog__grid',
    '.twoll-list-collections__grid',
    '.twoll-search-page__grid',
    '.twoll-cart__items',
    '.twoll-cart__perks',
    '.twoll-faq__layout'
  ].join(',');

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  function getType(element) {
    if (scaleSelectors.some((selector) => element.matches(selector))) {
      return 'twoll-animate--scale';
    }

    if (fadeSelectors.some((selector) => element.matches(selector))) {
      return 'twoll-animate--fade';
    }

    return 'twoll-animate--up';
  }

  function setup(root) {
    const scope = root || document;
    const elements = [];
    const seen = new Set();
    const groupCounts = new WeakMap();

    selectors.forEach((selector) => {
      scope.querySelectorAll(selector).forEach((element) => {
        if (seen.has(element) || element.dataset.twollAnimated === 'true') return;

        seen.add(element);
        elements.push(element);
      });
    });

    if (!elements.length) return;

    elements.forEach((element) => {
      const group = element.closest(staggerParents) || element.parentElement || scope;
      const currentIndex = groupCounts.get(group) || 0;
      const delay = Math.min(currentIndex * 45, 225);

      groupCounts.set(group, currentIndex + 1);
      element.classList.add('twoll-animate', getType(element));
      element.style.setProperty('--twoll-animation-delay', `${delay}ms`);
      element.dataset.twollAnimated = 'true';
    });

    const reveal = (element) => {
      element.classList.add('is-visible');
    };

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(reveal);
      document.documentElement.classList.add('twoll-animations-ready');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
      }
    );

    elements.forEach((element) => {
      const rect = element.getBoundingClientRect();

      if (rect.top < window.innerHeight * 0.92) {
        reveal(element);
        return;
      }

      observer.observe(element);
    });

    document.documentElement.classList.add('twoll-animations-ready');
  }

  ready(function () {
    setup(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
